import React, { useEffect, useState } from 'react';
import axios from '../services/api';

const AdminPanel = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/jobs');
        setJobs(response.data.jobs);
      } catch (err) {
        console.error('Error fetching jobs:', err);
      }
    };
    fetchJobs();
  }, []);

  const handleApprove = async (jobId) => {
    try {
      await axios.post(`/jobs/${jobId}/approve`);
      setJobs((prevJobs) =>
        prevJobs.map((job) => (job.id === jobId ? { ...job, status: 'approved' } : job))
      );
    } catch (err) {
      console.error('Error approving job:', err);
    }
  };

  const handleReject = async (jobId) => {
    try {
      await axios.post(`/jobs/${jobId}/reject`);
      setJobs((prevJobs) =>
        prevJobs.map((job) => (job.id === jobId ? { ...job, status: 'rejected' } : job))
      );
    } catch (err) {
      console.error('Error rejecting job:', err);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">Admin Panel</h1>

      {/* Pending Jobs */}
      <div>
        <h2 className="text-2xl font-bold text-royal-blue mb-4">Pending Jobs</h2>
        <ul>
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <li key={job.id} className="mb-4">
                <p>
                  {job.title} - {job.location} ({job.status})
                </p>
                <div className="space-x-2">
                  <button
                    onClick={() => handleApprove(job.id)}
                    className="bg-green-500 text-white px-2 py-1 rounded"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleReject(job.id)}
                    className="bg-red-500 text-white px-2 py-1 rounded"
                  >
                    Reject
                  </button>
                </div>
              </li>
            ))
          ) : (
            <p>No pending jobs found.</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AdminPanel;